import { render } from "./BNPLInformationV2.vue?vue&type=template&id=35a07909&scoped=true"
import script from "./BNPLInformationV2.vue?vue&type=script&lang=js"
export * from "./BNPLInformationV2.vue?vue&type=script&lang=js"

import "./BNPLInformationV2.vue?vue&type=style&index=0&id=35a07909&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a07909"]])

export default __exports__